import React from 'react'
import { ImageSourcePropType } from 'react-native'

import { Box } from 'widgets/Box'
import { Checkbox } from 'widgets/Checkbox/v2'
import { Image } from 'widgets/Image'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

type GroupInfoProps = {
  title: string
  subtitle?: string
  withImage?: boolean
  imageSource?: (ImageSourcePropType | undefined) & { uri?: string | undefined }
  withCheckbox?: boolean
  isChecked?: boolean
  onPress?: () => void
}

export const GroupInfo = ({
  title,
  subtitle,
  withImage = true,
  imageSource = defaultPostThumbnailUrl,
  withCheckbox = false,
  isChecked = false,
  onPress,
}: GroupInfoProps) => {
  return (
    <Box flexDirection='row' align='center' margin={{ vertical: 'sm' }}>
      {withImage && (
        <Box
          width={54}
          height={54}
          borderRadius='sm'
          backgroundColor='v2lightGrey'
          style={commonStyles.overflowHidden}
        >
          <Image style={commonStyles.fullSize} resizeMode='cover' source={imageSource} />
        </Box>
      )}

      <Box flex={1} margin={{ left: 'md' }}>
        <Text fontSize='md' bold numberOfLines={2} color='greyDarkest'>
          {title}
        </Text>
        {subtitle?.length && (
          <Text fontSize='sm' color='v2midGrey'>
            {subtitle}
          </Text>
        )}
      </Box>

      {withCheckbox && (
        <Pressable disabled={!onPress} onPress={onPress}>
          <Box padding='smd'>
            <Checkbox selected={isChecked} />
          </Box>
        </Pressable>
      )}
    </Box>
  )
}
